
import util from '@/javascript/util'
import mapUtil from '@/javascript/mapUtil'
import { formatDate } from "@/javascript/formatDate"
import Audio from './audio'

import Toast from 'vux/src/components/toast/index.vue'



import mapList from '@/components/public-components/mapList/index.vue'

export default {
directives: {
focus: function (el) {
el.focus()
}
},
components: {
Toast,

mapList
},
data () {
return {
normalData: {},
conData: [],
helpData: [],
lng: '',
lat: '',
baidYy: require('../../../audio/no.mp3'),
minHeight: 0,
helpShow: false,
explicitImplicit: false,
textContent: '',
ellipsisShow: false,
sessionId: '',
weatherData: [],
startRecord: false,
timer: '',
voiceTimer: '',
audio: null,
tokData: '',
isWeiXin: util.isWeiXin(),
toast: {
text: '',
show: false
},
showMapList: false,
guideData: {
title: "",
longitude: "",
latitude: ""
},
wxLink: false
}
},
created () {
this.$http.get('/api/wtcp-consultation/public/token/msg').then((res) => {
this.tokData = res.data
})
const _this = this

let ua = navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == "micromessenger") {

wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
_this.wxLink = true
} else {
console.log("不在小程序里");
}
})
} else {
_this.wxLink = false
console.log('不在微信里');
}
},
mounted () {
this.init()
},
watch: {
$route: {
handler () {
this.init()
},
immediate: true,
deep: true
},
tokData () {
if (!this.isWeiXin) {
return
}

const yuyin = []
this.$http.get('/static/json/lyx/question.json').then(res => {
this.$set(this, 'normalData', res.data)
}).then(() => {
this.normalData.question.forEach(item => {
yuyin.push(item.name)
})
if (this.tokData !== '' && !sessionStorage.getItem('consultationMessage')) {
this.tts('您好，我是您的智能助手。' + this.normalData.title + '猜您需要查询以下内容。' + yuyin.join(','))
}
})
},
textContent () {
this.textContent = this.textContent ? this.textContent.replace(/[\r\n]/g, "") : ''
}
},
methods: {

toPath (code, id) {
switch (code) {
case "125005002":
this.$router.push({ path: '/businessViews/' + code + '/' + id })
break
}
},

init () {
this.minHeight = document.documentElement.clientHeight
document.title = this.PAGE_TITLE + '智能问答'
/**
* 微信签名分享
*/
if (util.isWeiXin()) {
const shareData = typeof (shareData) === 'undefined' ? {
title: this.PAGE_TITLE + '智能问答',
desc: '',
imgUrl: '',
link: window.location.href
} : shareData;

this.$http.get('/api/wtcp-support/weixin/createJsapiSignature?url=' + encodeURIComponent(window.location.href) + '&appId=' + this.WX_APPID).then((response) => {
console.log(response, "response==");
util.initWxConfig(response.data.data, shareData)
mapUtil.locate((data) => {
that.locationResult(data)
}, (data) => {
that.locationResult(data)
})
})
}

if (!this.isWeiXin) {
return
}

if ('addEventListener' in document) {
document.addEventListener('DOMContentLoaded', function () {
FastClick.attach(document.body);
}, false);
}

const that = this
document.addEventListener("WeixinJSBridgeReady", function () {
document.getElementById('baidYyPlay').play()
}, false)

/**
*语音搜索指南
*/
that.$http.get('./static/json/lyx/consultationData.json').then((res) => {
that.$set(that, 'helpData', res.data)
})


that.$http.get('./static/json/lyx/question.json').then(res => {
that.$set(that, 'normalData', res.data)
}).then(() => {
/**
* 获取缓存数据初始化
*/
const sessionMessage = sessionStorage.getItem('consultationMessage')
if (sessionMessage) {
that.baidYy = ''
that.conData = JSON.parse(sessionMessage)
that.toBottom()
}
})


that.$http.get('./static/json/weather/weatherConditionData.json').then(res => {
that.$set(that, 'weatherData', res.data)
})


that.recordAnimate()
},

locationResult: function (val) {
this.lng = val.position.lng
this.lat = val.position.lat
},

yyAnimate () {
const speed = 10;
const tab = document.getElementById("anm_1");
const tab1 = document.getElementById("anm_2");
const tab2 = document.getElementById("anm_3");
tab2.innerHTML = tab1.innerHTML;

function Marquee () {
if (tab2.offsetWidth - tab.scrollLeft <= 0)
tab.scrollLeft -= tab1.offsetWidth
else {
tab.scrollLeft++;
}
}

let MyMar = setInterval(Marquee, speed);
tab.onmouseover = function () {
clearInterval(MyMar)
};
tab.onmouseout = function () {
MyMar = setInterval(Marquee, speed)
};
},
ruouterLink (e) {
this.baidYy = ''
},
gpsJump: function (name, lng, lat) {
this.baidYy = ''
this.guideData.title = name
this.guideData.longitude = lng
this.guideData.latitude = lat
const _this = this
/**
* 定位
*/
if (!_this.wxLink) {
_this.showMapList = true
} else {
let key = 'EYDBZ-IRR66-KDTS7-EY6MR-FJEFF-QKB4B';  
let referer = '自游海晏';   
let endPoint = JSON.stringify({  //终点
'name': _this.guideData.title,
'latitude': _this.guideData.latitude,
'longitude': _this.guideData.longitude
});
let navigation = 1;
wx.miniProgram.navigateTo({
url: 'plugin://routePlan/index?key=' + key + '&referer=' + referer + '&endPoint=' + endPoint + '&navigation=' + navigation
})
}


},

requestData (e) {
if (!this.lat || !this.lng) {
this.toast.text = '未获取到您的当前位置，稍等请重试'
this.toast.show = true
this.ellipsisShow = false

return
}

this.ellipsisShow = true
this.$http.get('/api/wtcp-consultation/public/conversation/msg?query=' + encodeURI(e) + '&lon=' + this.lng + '&lat=' + this.lat + '&sessionId=' + this.sessionId).then(res => {
const that = this
if (res.data.msg === 'success') {
if (res.data.data.intentType === 'satisfy') {
that.sessionId = ''
} else {
that.sessionId = res.data.data.sessionId
}
if (res.data.data.models[0].replyType === "failure") {
that.conData.push({
type: 'failure',
say: '我联系不到服务了，请重新尝试'
})
that.tts('我联系不到服务了，请重新尝试');
that.saveMessage()
}
if (res.data.data.intent === "WEATHER" && res.data.data.models[0].options.length > 0) {

const data = res.data.data
if (data.models[0].options.length === 1) {
const phenomenon = data.models[0].options[0].original.phenomenon;
data.models[0].options.map(item => {
item.original.day = formatDate(item.original.day, 'MM月dd日');
item.original.update_time = formatDate(item.original.update_time, 'hh:mm');

that.weatherData.forEach(itemWea => {

if (phenomenon === itemWea.codeName && itemWea.typeCode === "1") {
item.original.weatherTopBg = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/rain_bg.png"
item.original.weatherTopIcon = that.STATIC_BASE_URL + itemWea.weatherIconUrl
item.original.weatherDes = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/wea-qus-3.png"
}

if (phenomenon === itemWea.codeName && itemWea.typeCode === "2") {
item.original.weatherTopBg = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/snow_bg.png"
item.original.weatherTopIcon = that.STATIC_BASE_URL + itemWea.weatherIconUrl
item.original.weatherDes = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/wea-qus-3.png"
}

if (phenomenon === itemWea.codeName && itemWea.typeCode === "3") {
item.original.weatherTopBg = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/fine_bg.png"
item.original.weatherTopIcon = that.STATIC_BASE_URL + itemWea.weatherIconUrl
item.original.weatherDes = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/wea-qus-2.png"
}

if (phenomenon === itemWea.codeName && itemWea.typeCode === "4") {
item.original.weatherTopBg = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/sandDust_smog.png"
item.original.weatherTopIcon = that.STATIC_BASE_URL + itemWea.weatherIconUrl
item.original.weatherDes = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/wea-qus-2.png"
}

if (phenomenon === itemWea.codeName && itemWea.typeCode === "5") {
item.original.weatherTopBg = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/cloudy_bg.png"
item.original.weatherTopIcon = that.STATIC_BASE_URL + itemWea.weatherIconUrl
item.original.weatherDes = that.STATIC_BASE_URL + "/images/weather/weather-top-bg/wea-qus-1.png"
}
})
})
} else {
data.models[0].options.map(item => {
item.original.day = formatDate(item.original.day, 'MM月dd日');
that.weatherData.forEach(res => {
if (item.original.day_phenomenon === res.code && res.typeCode === '1') {
item.original.day_phenomenon = res.codeName
item.original.day_icon = res.weatherIconUrl
item.original.day_bg = "/images/weather/weather-top-bg/rain_bg.png"
}
if (item.original.day_phenomenon === res.code && res.typeCode === '2') {
item.original.day_phenomenon = res.codeName
item.original.day_icon = res.weatherIconUrl
item.original.day_bg = "/images/weather/weather-top-bg/snow_bg.png"
}
if (item.original.day_phenomenon === res.code && res.typeCode === '3') {
item.original.day_phenomenon = res.codeName
item.original.day_icon = res.weatherIconUrl
item.original.day_bg = "/images/weather/weather-top-bg/fine_bg.png"
}
if (item.original.day_phenomenon === res.code && res.typeCode === '4') {
item.original.day_phenomenon = res.codeName
item.original.day_icon = res.weatherIconUrl
item.original.day_bg = "/images/weather/weather-top-bg/sandDust_smog.png"
}
if (item.original.day_phenomenon === res.code && res.typeCode === '5') {
item.original.day_phenomenon = res.codeName
item.original.day_icon = res.weatherIconUrl
item.original.day_bg = "/images/weather/weather-top-bg/cloudy_bg.png"
}
})
})
}
that.conData.push({
type: 'weather',
say: res.data.data
})
if (res.data.data.models[0].options.length === 1) {
const wCont = res.data.data.models[0].options[0].original
let yuyinW = wCont.loc + '。' + wCont.day + '。天气' + wCont.phenomenon + '。气温' + wCont.temperature + '℃'
that.tts(yuyinW)
that.saveMessage()
} else {
const wCont = res.data.data.models[0].options
const tThreeDay = []
for (let i = 0; i < wCont.length; i++) {
tThreeDay.push(wCont[i].original.day + '。天气' + wCont[i].original.day_phenomenon + '。最低气温' + wCont[i].original.low_temperature + '℃。最高气温' + wCont[i].original.height_temperature + '℃')
}
that.tts(wCont[0].original.loc + '。' + tThreeDay.join(','))
that.saveMessage()
}
}

if (res.data.data.models[0].replyType === "guide") {
const guiData = []
const conty = res.data.data.models[0].replyContent ? res.data.data.models[0].replyContent : '猜您需要查询以下内容。'
for (let i = 0; i < res.data.data.models[0].options.length; i++) {
if (res.data.data.models[0].options[i].optionType === '125002001' || res.data.data.models[0].options[i].optionType === '125002002') {
guiData.push(res.data.data.models[0].options[i].original._source.title)
} else if (res.data.data.models[0].options[i].optionType === '125005002') {
guiData.push(res.data.data.models[0].options[i].original.title)
} else {
guiData.push(res.data.data.models[0].options[i].original)
}
}
that.tts(conty)
that.conData.push(res.data.data)
that.saveMessage()
}
if (res.data.data.models[0].replyType === "detail") {
that.conData.push(res.data.data)
if (res.data.data.models[0].options[0].optionType === '125002002') {
that.tts(res.data.data.models[0].options[0].original._source.description ? res.data.data.models[0].options[0].original._source.description : '信息正在维护中······')
}
if (res.data.data.models[0].options[0].optionType === '125001001') {
that.tts(res.data.data.models[0].options[0].original.scenicEntity.summary)
}
if (res.data.data.models[0].options[0].optionType === '125002003' || res.data.data.models[0].options[0].optionType === '125008002') {
that.tts(res.data.data.models[0].options[0].original.summary ? res.data.data.models[0].options[0].original.summary : '信息正在维护中······')
}
if (res.data.data.models[0].options[0].optionType === '10009') {
that.tts(res.data.data.models[0].options[0].original.traffic)
}
that.saveMessage()
}
if (res.data.data.models && res.data.data.models.length === 1) {
if (res.data.data.models[0].replyType === "text") {
that.conData.push(res.data.data)
let data = res.data.data.models[0].replyContent
let result = data.replace(/&nbsp|<br>/g, '')
that.tts(result)
that.saveMessage()
}
}
if (res.data.data.models && res.data.data.models.length === 2) {
if (res.data.data.models[0].replyType === "text") {
that.conData.push(res.data.data)
let data = res.data.data.models[0].replyContent
let result = data.replace(/&nbsp|<br>/g, '');
const twData = []
if (res.data.data.models[1].replyContent && res.data.data.models[1].replyType === "guide") {
twData.push(res.data.data.models[1].replyContent)
for (let i = 0; i < res.data.data.models[1].options.length; i++) {
twData.push(res.data.data.models[1].options[i].original.name)
}
}
that.tts(result + '。' + twData)
that.saveMessage()
}
}
that.toBottom()
} else {
that.conData.push({
type: 'failure',
say: '我联系不到服务了，请重新尝试'

})
that.tts('我联系不到服务了，请重新尝试');
that.saveMessage()
that.toBottom()
}
}).then(() => {
this.ellipsisShow = false
})
},

normalSearchClick (e) {
this.conData.push({
type: 'mine',
say: e
})
this.toBottom();
this.requestData(e);
},
stopRecord () {
const that = this
that.startRecord = false
wx.stopRecord({
success: function (res) {
const localId = res.localId
wx.translateVoice({
localId: localId,
isShowProgressTips: 1,
success: function (response) {
that.textContent = response.translateResult
if (that.textContent) {
that.sendText()
} else {
that.conData.push({
type: 'notHear'
})
that.saveMessage()
that.toBottom()
}
}
})
}
})
},
getKeyboard: function () {
this.explicitImplicit = true
this.textContent = ''
},

toBottom () {
const that = this
setTimeout(function () {
window.scrollTo(0, that.$refs.container.offsetHeight - that.minHeight - 5)
}, 200)
},

sendText: function () {
this.toBottom()
this.explicitImplicit = false
this.textContent = this.textContent ? this.textContent.replace(/[\r\n]/g, "") : ''
if (this.textContent) {
this.conData.push({
type: 'mine',
say: this.textContent
})
this.saveMessage()
this.ellipsisShow = true
this.toBottom()
this.requestData(this.textContent)
}
},
toggleHelp () {
this.helpShow = !this.helpShow
},
toHtml: function (value) {
const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' }
return value.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) {
return arrEntities[t]
})
},

helpSelect (text) {
this.toggleHelp()
this.textContent = text
this.sendText()
},
saveMessage () {
sessionStorage.setItem('consultationMessage', JSON.stringify(this.conData))
},

tts: function (e) {
const that = this


that.audio = Audio({
tex: e,
tok: that.tokData,
spd: 5,
pit: 5,
vol: 15,
per: 4
}, {
volume: 0.3,
autoDestory: true,
timeout: 10000,
hidden: true,
pauseAudio: false,
autoplay: "autoplay",
onInit: function (htmlAudioElement) {
},
onSuccess: function (e) {
this.baidYy = e
const audio = document.getElementById('baidYyPlay');
audio.setAttribute('src', this.baidYy);
document.addEventListener("WeixinJSBridgeReady", function () {
audio.play()
}, false)
if (audio.paused) {
audio.play()
}
},
onError: function (text) {
console.log(text)
},
onTimeout: function () {
console.log('timeout')
}
})
},
scenicSummaryToggle (idx) {
if (this.conData[idx].models[0].options[0].original.scenicEntity.summaryAll) {
this.$set(this.conData[idx].models[0].options[0].original.scenicEntity, 'summaryAll', false)
} else {
this.$set(this.conData[idx].models[0].options[0].original.scenicEntity, 'summaryAll', true)
}
},
detailSummaryToggle (idx) {
if (this.conData[idx].models[0].options[0].original.summaryAll) {
this.$set(this.conData[idx].models[0].options[0].original, 'summaryAll', false)
} else {
this.$set(this.conData[idx].models[0].options[0].original, 'summaryAll', true)
}
},
replyContentToggle (idx) {
if (this.conData[idx].models[0].textAll) {
this.$set(this.conData[idx].models[0], 'textAll', false)
} else {
this.$set(this.conData[idx].models[0], 'textAll', true)
}
},
getDistance (lng, lat) {
return mapUtil.getDistance(this.lng, this.lat, lng, lat)
},
hideInputPop () {
this.explicitImplicit = false
},
recordAnimate () {
/**
* 以下是录音动画效果
*/
let unit = 50, canvas, context, height, width, xAxis, yAxis, draw;

/**
* Init function.Initialize variables and begin the animation.
*/
function init () {
let canvas = document.getElementById("sineCanvas");
if (!canvas) {
return
}
context = canvas.getContext("2d");

height = canvas.height;
width = canvas.width;

xAxis = Math.floor(height / 2);
yAxis = 0;

context.save();
draw();
}

/**
* Draw animation function.
*
* This function draws one frame of the animation, waits 25ms, and then calls
* itself again.
*/
draw = function () {

context.clearRect(0, 0, width, height);


const grd1 = context.createLinearGradient(0.000, 0.000, 800.000, 0.000);
grd1.addColorStop(0, '#5792FF');
grd1.addColorStop(1, '#5792FF');
context.strokeStyle = grd1;
context.lineWidth = 3;

context.beginPath();
drawSine(draw.t * 3, unit, 0, 2);
context.stroke();


const grd2 = context.createLinearGradient(0.000, 0.000, 800.000, 0.000);
grd2.addColorStop(0, '#507AFD');
grd2.addColorStop(1, '#507AFD');
context.strokeStyle = grd2;
context.lineWidth = 3;

context.beginPath();
drawSine(draw.t * 3, unit, 50, 2);
context.stroke();


const grd3 = context.createLinearGradient(0.000, 0.000, 800.000, 0.000);
grd3.addColorStop(0, '#495FFB');
grd3.addColorStop(1, '#495FFB');
context.strokeStyle = grd3;
context.lineWidth = 3;

context.beginPath();
drawSine(draw.t * 3, unit, -50, 2);
context.stroke();


context.restore();


draw.seconds = draw.seconds - .007;
draw.t = draw.seconds * Math.PI;
setTimeout(draw, 35);
};

draw.seconds = 0;
draw.t = 0;

/**
* Function to draw sine
*
* The sine curve is drawn in 10px segments starting at the origin.
*/
function drawSine (t, unitval, offset, direction) {

for (let i = yAxis; i <= width; i += 10) {
const x = t + (-yAxis + i) / unitval;
const y = Math.sin(x) * direction;
context.lineTo(i + offset, (unitval / 3) * y + xAxis);
}
}

init()
},
textareaFocus () {
document.getElementById('pop_up_input').scrollTop = 0
},
textareaBlur () {
this.toBottom()
},
touchstartFun () {
const that = this
that.startRecord = true
wx.startRecord()
that.tts(' ')
navigator.vibrate = navigator.vibrate || navigator.webkitVibrate || navigator.mozVibrate || navigator.msVibrate;
if (navigator.vibrate) {
navigator.vibrate(100);
}
that.timer = setTimeout(function () {
that.stopRecord()
}, 60000)
},
touchendFun () {
const that = this
that.tts(' ')
that.stopRecord()
if (navigator.vibrate) {
navigator.vibrate(0);
}
clearTimeout(that.timer)
clearTimeout(that.voiceTimer)
},
getMapLink (data) {
if (data.businessEntity.serviceFacility.indexOf('119015') > -1) {
return '/itelgeGuide/' + data.scenicEntity.id
} else {
return false
}
}
}
}
